/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getAgendaOptions = (params) => makeApiCall(`/agendas/list`, 'GET', params);
export const getProductOptions = (params) =>
  makeApiCall(`/products/6ps-utilization/agenda/product-list`, 'POST', params);
export const getSpecialtyOptions = (params) => makeApiCall(`/user/specialty`, 'GET', params);
export const getGroupOptions = (params) => makeApiCall(`/user/md-group`, 'GET', params);

export const postReportExport = (params) =>
  makeApiCall(`/products/6ps-utilization/report/export`, 'POST', params);

export const postPerSegmentExport = (params) =>
  makeApiCall(`/products/6ps-utilization/per-segment/report/export`, 'POST', params);

export const postPerMDExport = (params) =>
  makeApiCall(`/products/6ps-utilization/per-md/report/export`, 'POST', params);

export const getProductUtil6psExport = (params) =>
  makeApiCall(`/products/utilization/6ps/export`, 'GET', params);
